import UserPreferencesService from '../../../../services/UserPreferencesService';

const userPreferencesService = UserPreferencesService.get();

export default {
  listVariant: userPreferencesService.initializeListVariant(),
  showFilters: false,
  showChat: false
};
